export enum DocumentFormId {
  MedicalBillingDispute = 1,
  // PAR L1 Request
  ConfirmationL1 = 6,
  MedicationL1 = 10,
  DurableMedicalEquipmentL1 = 8,
  NonMtgOver1000L1 = 4,
  NonMtgUnder1000L1 = 9,
  SpecialServicesL1 = 5,
  VarianceL1 = 7,
  // PAR L1 Response Draft
  ConfirmationL1ResponseDraft = 81,
  VarianceL1ResponseDraft = 82,
  DurableMedicalEquipmentL1ResponseDraft = 83,
  NonMtgOver1000L1ResponseDraft = 84,
  NonMtgUnder1000L1ResponseDraft = 85,
  MedicationL1ResponseDraft = 86,
  SpecialServicesL1ResponseDraft = 87,
  // PAR Responses
  ConfirmationResponseDenied = 56,
  ConfirmationResponseGranted = 48,
  ConfirmationResponseGrantedInPart = 64,
  DurableMedicalEquipmentResponseDenied = 55,
  DurableMedicalEquipmentResponseGranted = 47,
  DurableMedicalEquipmentResponseGrantedInPart = 63,
  MedicationL1ResponseDenied = 45,
  MedicationL1ResponseGranted = 46,
  MedicationL1ResponseGrantedInPart = 53,
  MedicationL2ResponseDenied = 54,
  MedicationL2ResponseGranted = 61,
  MedicationL2ResponseGrantedInPart = 62,
  NonMtgOver1000ResponseDenied = 59,
  NonMtgOver1000ResponseGranted = 51,
  NonMtgOver1000ResponseGrantedInPart = 67,
  NonMtgUnder1000ResponseDenied = 60,
  NonMtgUnder1000ResponseGranted = 52,
  NonMtgUnder1000ResponseGrantedInPart = 68,
  SpecialServicesResponseDenied = 58,
  SpecialServicesResponseGranted = 50,
  SpecialServicesResponseGrantedInPart = 66,
  VarianceResponseDenied = 57,
  VarianceResponseGranted = 49,
  VarianceResponseGrantedInPart = 65,
  // PAR L2 Request
  MedicationL2 = 44,
  // PAR L2 Response Draft
  ConfirmationL2ResponseDraft = 88,
  VarianceL2ResponseDraft = 89,
  DurableMedicalEquipmentL2ResponseDraft = 90,
  NonMtgOver1000L2ResponseDraft = 91,
  NonMtgUnder1000L2ResponseDraft = 92,
  MedicationL2ResponseDraft = 93,
  SpecialServicesL2ResponseDraft = 94,
  // PAR Review GAD
  DurableMedicalEquipmentReviewGadDraft = 104,
  ConfirmationReviewGadDraft = 105,
  VarianceReviewGadDraft = 106,
  SpecialServicesReviewGadDraft = 107,
  NonMtgOver1000ReviewGadDraft = 108,
  NonMtgUnder1000ReviewGadDraft = 109,
  // PAR L3 Request
  ConfirmationL3 = 20,
  MedicationL3 = 24,
  DurableMedicalEquipmentL3 = 22,
  NonMtgUnder1000L3 = 23,
  SpecialServicesL3 = 19,
  VarianceL3 = 21,
}
